package top.wcpe.allincore.ui.runtime.render.layer

import kotlin.jvm.JvmName

/**
 * 变换栈条目：对应 [top.wcpe.allincore.ui.runtime.render.UiRenderBridge] 的三种 pushTransform 重载。
 *
 * 各子类型访问器经 [JvmName] 保留 record 风格的 `tx()` / `mat()` 等 Java 方法 ABI，
 * 与 [LayerBufferingBridge] 等 Java 调用方现有的模式匹配 + 方法式访问一致。
 */
sealed interface TransformEntry {

    /** 对应 pushTransform(tx, ty, scaleX, scaleY)。 */
    data class TranslateScale(
        @get:JvmName("tx") val tx: Float,
        @get:JvmName("ty") val ty: Float,
        @get:JvmName("sx") val sx: Float,
        @get:JvmName("sy") val sy: Float,
    ) : TransformEntry

    /**
     * 对应 pushTransform3x3(float[9])：行优先 3×3 仿射矩阵。
     *
     * 构造时深拷贝入参数组，确保不可变（与原 record 紧凑构造器的防御性拷贝一致）。
     */
    class Matrix3x3(mat: FloatArray) : TransformEntry {
        @get:JvmName("mat")
        val mat: FloatArray = mat.copyOf()
    }

    /**
     * 对应 pushTransform4x4(float[16])：列优先 4×4 矩阵。
     *
     * 构造时深拷贝入参数组，确保不可变（与原 record 紧凑构造器的防御性拷贝一致）。
     */
    class Matrix4x4(mat: FloatArray) : TransformEntry {
        @get:JvmName("mat")
        val mat: FloatArray = mat.copyOf()
    }
}
